module.exports = __webpack_public_path__ + "static/slide-2-d01e61e8fa961cf93ddf051ce28525a7.jpg";